'use client'

import { cn } from '@/lib/utils'
import { Skeleton, Spinner } from '@/ui/components'
import { memo, useEffect, useState } from 'react'

interface Props {
  src: string
  className?: string
}

// Fallback in case the iframe `load` event fired before hydration
const LOADING_TIMEOUT = 8000

const MapFrame = ({ src, className }: Props) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => setIsLoaded(true), LOADING_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div className={cn('pb-lg', className)}>
      <div
        className={
          'relative aspect-video w-full overflow-hidden border border-neutral-300'
        }
      >
        {!isLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <Skeleton className="absolute inset-0 rounded-none bg-neutral-300" />
            <Spinner className="relative size-8 text-neutral-600" />
          </div>
        )}
        <iframe
          className={cn(
            'absolute inset-0 size-full transition-opacity duration-300',
            !isLoaded && 'opacity-0'
          )}
          src={src}
          frameBorder="0"
          onLoad={() => setIsLoaded(true)}
        />
      </div>
    </div>
  )
}

export default memo(MapFrame)
